// SERVICES


// STATE
import EnnounsmentService from "@/services/vacancy/announsment.servise";

const state = {
    item: {},
    list: [],
    total: null,
    totalArchive: null,
    totalActive: null,
    archiveList: [],
    sumCountOfVacancy: null,
    countSendDocumentEmployeeNumber: null,
    countStaffListVacancyNumber: null,
    listStaffPosition: [],
    totalStaffPosition: 0,
    listLocationType: [],
    totalLocationType: 0,
    listVacancy: [],
    totalVacancy: 0,
    coordinate: {
        latitude: '',
        longitude: '',
    }
};

// GETTERS
const getters = {}

// ACTIONS
const actions = {
    async getList({ commit }, { params, isArchive }) {
        try {
            const action = isArchive ? 'getArchiveList' : 'getList'
            const res = await EnnounsmentService[action](params)
            await commit('setListResponse', res);
        } catch (error) {
        }
    },
    async getListLocationType({ commit }, params) {
        try {
            const res = await EnnounsmentService.getListLocationType(params)
            await commit('setLocationTypeResponse', res);
        } catch (error) {
        }
    },
    async getListStaffPosition({ commit }, params) {
        try {
            const res = await EnnounsmentService.getListStaffPosition(params)
            await commit('setListStaffPositionResponse', res);
        } catch (error) {
        }
    },
    async getListVacancy({ commit }, params) {
        try {
            const res = await EnnounsmentService.getVacancyList(params)
            await commit('setListVacancyResponse', res);
        } catch (error) {
        }
    },
    async getVacancyListIn({ commit }, params) {
        try {
            const res = await EnnounsmentService.getVacancyListLogin(params)
            await commit('setListVacancyResponse', res);
        } catch (error) {
        }
    },

}

// MUTATIONS
const mutations = {
    setListResponse(state, payload) {
        state.list = payload.data.list
        state.total = payload.data.total
        state.sumCountOfVacancy = payload.data.sumCountOfVacancy
        state.countSendDocumentEmployeeNumber = payload.data.countSendDocumentEmployeeNumber
        state.countStaffListVacancyNumber = payload.data.countStaffListVacancyNumber
        state.totalActive = payload.data.totalActive ||  state.totalActive
        state.totalArchive = payload.data.totalArchive || state.totalArchive
    },
    setLocationTypeResponse(state, payload) {
        state.listStaffPosition = payload.data
        state.totalStaffPosition = payload.data.length
    },
    setListStaffPositionResponse(state, payload) {
        state.listLocationType = payload.data
        state.totalLocationType = payload.data.length
    },
    setListVacancyResponse(state, payload) {
        state.coordinate.latitude = payload.data.latitude
        state.coordinate.longitude = payload.data.longitude
        state.listVacancy = payload.data.list
        state.totalVacancy = payload.data.total
    },
}

export const ennounsment = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
